import script from "./ContentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContentComponent.vue?vue&type=style&index=0&id=86aeebf2&lang=scss"

const __exports__ = script;

export default __exports__